"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var listMissingProperties_1 = __importDefault(require("./helper/listMissingProperties"));
function objectShouldHave(requiredProperties) {
    return function (obj) {
        var missingProperties = listMissingProperties_1.default(obj, { requiredProperties: requiredProperties });
        if (missingProperties.length) {
            console.error.apply(console, __spreadArrays(['Object (', obj, ') is missing the following properties, which are all required:\n'], missingProperties.map(function (prop) { return "- " + prop + "\n"; })));
            return false;
        }
        else {
            return true;
        }
    };
}
exports.default = objectShouldHave;
//# sourceMappingURL=objectShouldHave.js.map